import React, { Fragment, useEffect } from "react";
import HUDInfo from "./HUDInfo";
import "./HUDLabel.scss";
import HUDStat from "./HUDStat";
import PerfectScrollbar from "react-perfect-scrollbar";

export default function HUDLabel({ stats, onMouseOver, onMouseOut })
{

    useEffect(() =>
    {
        //console.log("stats", stats);
        return (() =>
        {
            
        })
    });

    return (
        <PerfectScrollbar onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
            <div onMouseOver={onMouseOver} onMouseOut={onMouseOut} className={"hud-label tabs" + (stats.dataTabConfigurations.length)}>
            {stats.dataTabConfigurations.map((tab, index) => (
                <Fragment key={"tab" + index} >
                <div className="nav-item">{tab.name }</div>
                <div className="hud-tab">
                {tab.blocs.map((bloc, index) => (
                    <Fragment key={"bloc"+ index}>
                        {bloc.showBlocName ? <div className="hud-bloc name">{bloc.name}</div> : <></>}
                        <div className="hud-bloc">
                            {bloc.values.map((value, index) => (
                                value.stat ? <HUDStat stat={value} key={"stat"+index} displayType={bloc.displayType} layoutType={bloc.layoutType}></HUDStat>:<HUDInfo stat={value} key={"info"+index} displayType={bloc.displayType} layoutType={bloc.layoutType}></HUDInfo>
                            ))}
                        </div>
                    </Fragment>
                ))}
                </div>
                </Fragment>
            ))}
            </div>
        </PerfectScrollbar>
    )
}